import { render, staticRenderFns } from "./IconBoleto.vue?vue&type=template&id=5c6c551f&"
import script from "./IconBoleto.vue?vue&type=script&lang=ts&"
export * from "./IconBoleto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports